export const selectFooter = state => state.footer;
